module.exports = __webpack_public_path__ + "img/009.3acd40b3.jpg";